import { Link } from "react-router-dom";
import styled from "styled-components";

export const HeaderContainer = styled("div")(({ isHomePage }) => ({
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
  position: "fixed",
  zIndex: 1,
  textAlign: "center",
  marginTop: "27px",
  left: "unset",
  color: isHomePage ? "white" : "#004081",
  background: isHomePage ? "transparent" : "transparent",
  top: 0,
  img: {
    filter: isHomePage
      ? "unset"
      : "invert(42%) sepia(100%) saturate(1511%) hue-rotate(162deg) brightness(96%) contrast(101%)",
  },
  "@media (width <= 768px)": {
    marginLeft: "12px",
  },
  a: {
    ":hover": {
      textDecoration: "underline",
    },
  },
  span: {
    cursor: "pointer",
    padding: "6px 8px",
  },
}));

export const HeaderLinks = styled(Link)(({ state }) => ({
  color: state.isHomePage || state.isDivisionPage ? "white" : "#004081",
  textTransform: "capitalize",
  textDecoration: "none",
  padding: "4px 10px",
  cursor: "pointer",
  fontSize: "0.9375rem",
  fontFamily: "Outfit",
  lineHeight: "1.5rem",
  gap: "30px",
  ":hover": {
    span: {
      textDecoration: "underline",
      //   borderBottom: "1px solid #fff",
    },
  },
}));

const NavbarWrapper = styled("nav")({
  flex: 1,
  alignSelf: "flex-start",
  padding: "1rem 3rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "white",
});

const NavbarItems = styled("ul")({
  display: "flex",
  listStyle: "none",
});

const NavbarItem = styled("ul")({
  padding: "0rem 1rem",
  cursor: "pointer",
});

// export const Navbar = {
//   Wrapper: NavbarWrapper,
//   Items: NavbarItems,
//   Item: NavbarItem,
// };

// const MobileNavbarWrapper = styled(Navbar.Wrapper)({
//   position: "fixed",
//   width: "100vw",
//   bottom: 0,
//   justifyContent: "center",
// });

// const MobileNavbarItems = styled(Navbar.Items)({
//   flex: 1,
//   padding: "0 2rem",
//   justifyContent: "space-around",
// });

// const MobileNavbarItem = styled(Navbar.Item)({
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   fontSize: "1.2rem",
// });

export const Navbar = {
  Wrapper: styled.nav`
    flex: 1;

    align-self: flex-start;

    padding: 1rem 3rem;

    display: flex;
    justify-content: space-between;
    align-items: center;

    background-color: white;
  `,
  Logo: styled.h1`
    border: 1px solid gray;
    padding: 0.5rem 1rem;
  `,
  Items: styled.ul`
    display: flex;
    list-style: none;
  `,
  Item: styled.li`
    padding: 0 1rem;
    cursor: pointer;
  `,
};

export const MobileNavbar = {
  Wrapper: styled(Navbar.Wrapper)`
    position: fixed;
    // width: 100vw;
    bottom: 0;
    justify-content: center;
  `,
  Items: styled(Navbar?.Items)`
    flex: 1;
    padding: 0 2rem;

    justify-content: space-around;
  `,
  Item: styled(Navbar?.Item)`
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 1.2rem;
  `,
  Icon: styled.span``,
};

// export const MobileNavbar = {
//   Wrapper: MobileNavbarWrapper,
//   Items: MobileNavbarItems,
//   Item: MobileNavbarItem,
// };
